import React from 'react'
import { IS_SERVER } from '../constants/ssr'

export const useLocation = () => {
  try {
    return IS_SERVER ? { search: '', href: '', pathname: '' } : window.location
  } catch (error) {
    return { search: '', href: '', pathname: '' }
  }
}
